import React from 'react'
import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>O'qituvchi yaratish</title>
		</Helmet>
	)
}

export default Head
